import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useFormContext } from "@4uhub/lib4uhub";
import { IIServiceType } from "../../../../../../../models/i-service-type";
import { TIServiceForm } from "../../iServiceSchema";
import { IServiceType } from "../IServiceType";
import { useIServiceType } from "../useIServiceType";
import { SGU } from "./SGU";

interface ISGUWrapperProps {
  iServiceTypes: IIServiceType[];
}

const FIELD_NAME = "sgu";

const SGU_IMAGE = { src: "/iServices/sgu.png", alt: "SGU" };

const translationPath = "page.4uBus.register.iService.";

export const SGUWrapper = memo(({ iServiceTypes }: ISGUWrapperProps) => {
  const { id } = useParams();

  const { t } = useTranslation();

  const { setValue, getValues } = useFormContext<TIServiceForm>();

  const { sguValues } = useIServiceType();

  const sguType = iServiceTypes.find((item) => item.code === sguValues.code);

  const [isSelected, setIsSelected] = useState(() => {
    const sgu = getValues(FIELD_NAME);
    const iServiceType = getValues("iServiceType");
    return !!sgu || iServiceType?.code === sguValues.code;
  });

  const handleConfirm = () => {
    if (sguType) {
      setValue("iServiceType", sguType);
    }
    setValue(FIELD_NAME, sguValues.defaultValues);
    setIsSelected(true);
  };

  const handleClearConfigs = () => {
    setValue("configs", null);
    setValue("companyDigitalCertificate", null);
    setValue("iServiceType", null);
    setValue(FIELD_NAME, null);
    setIsSelected(false);
  };

  const handleOpen = () => {
    setValue(FIELD_NAME, sguValues.defaultValues);
  };

  const handleCloseSelected = () => {
    setValue(FIELD_NAME, sguValues.defaultValues);
  };

  const isEditingScreen = !!id;

  if (!sguType) {
    return null;
  }

  return (
    <IServiceType
      img={SGU_IMAGE}
      renderComponent={() => <SGU />}
      isSelected={isSelected}
      isEditingScreen={isEditingScreen}
      getFormattedData={() => ({})}
      onConfirm={handleConfirm}
      onClearConfigs={handleClearConfigs}
      onOpen={handleOpen}
      onCloseSelected={handleCloseSelected}
      iServiceTypeName={FIELD_NAME}
      serviceName={t(translationPath + "sgu")}
      showConfirmButton={false}
    />
  );
});
